<template>
  <div id="app" :class="{landing:$router.currentRoute.name === 'landing'}">
    <router-view />
    <notifications group="success" position="bottom left" classes="success-notify" width="350px" />
    <notifications group="error" position="bottom left" classes="error-notify" />
  </div>
</template>

<script>
export default {
  name: "app",
};
</script>
<style lang="scss">
a {
  text-decoration: none !important;
  &:hover {
    text-decoration: none !important;
  }
  color: inherit !important;
}
.v--modal-box {
  @extend %bRadius;
}
body {
  font-family: "Montserrat", sans-serif;
  text-size-adjust: none;
  font-smoothing: antialiased;
  -webkit-font-smoothing: antialiased;
  text-rendering: optimizeLegibility;
}
#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  min-height: 100vh;
  background: #fff;
  .container,
  .container-fluid {
    min-width: 960px;
  }
  &.landing {
    .container {
      max-width: 960px;
      @media (max-width: $mobileSize) {
        max-width: 100%;
        padding: 16px 12px !important
      }
    }
  }
  .success-notify {
    background-color: #42b983;
  }
  .error-notify {
    background-color: #e84848;
  }
  .success-notify,
  .error-notify {
    margin: 0 0 10px 10px;
    border-radius: 10px;
    // Style of the notification itself
    padding: 10px 20px;
    color: #fff;
    .notification-title {
      font-weight: bold;
      font-size: 18px;
      line-height: 22px;
      margin-bottom: 7px;
    }

    .notification-content {
      font-size: 18px;
      line-height: 22px;
    }

    &.my-type {
    }
  }
}
#nav {
  padding: 30px;
  a {
    font-weight: bold;
    color: #2c3e50;
    &.router-link-exact-active {
      color: #42b983;
    }
  }
}

.bread-crumbs {
  font-size: 14px;
  line-height: 20px;
  display: flex;
  align-items: center;
  color: $calmColor;
  margin-bottom: 20px;

  a {
    &:first-child {
      margin-right: 5px;
    }
    &:last-child {
      margin-left: 5px;
    }
  }
}
input,
textarea,
select {
  outline: 0 !important;
  -webkit-overflow-scrolling: touch;
  -webkit-text-size-adjust: none;
  &:focus,
  &:active,
  &:visited,
  &:hover {
    outline: 0 !important;
    //user-select: none!important;
    border-color: inherit;
    box-shadow: none !important;
  }
}
</style>
